
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[companyId]",
      function () {
        return require("private-next-pages/[companyId]/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[companyId]"])
      });
    }
  